var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JsonBuilder',{staticClass:"mt-4",attrs:{"node-name":_vm.nodeName},model:{value:(_vm.builderNodes),callback:function ($$v) {_vm.builderNodes=$$v},expression:"builderNodes"}})}
var staticRenderFns = []

export { render, staticRenderFns }